import { create } from "zustand";

type ModalIds = 'profileInfo' | 'profilePass'

type ModalsState = {
  openId: ModalIds | null;
  open: (id: ModalIds) => void;
  change: (id: ModalIds | null) => void;
  isOpen: (id: ModalIds) => boolean;
};

export const useModals = create<ModalsState>((set, get) => ({
  openId: null,
  open: (id) => set({ openId: id }),
  change: (id) => set({ openId: id }),
  isOpen: (id) => get().openId === id,
}));